import { useTranslation } from "react-i18next";

import { Tag, TagProps } from "@industriousoffice/react-components";
import { Invoice } from "@/api/opb/opbTypes";
import { getInvoiceStatus, getInvoiceStatusTagVariant } from "@/utils/invoice";

interface PaymentStatusTagProps extends Omit<TagProps, "text"> {
  invoice: Invoice;
}

function PaymentStatusTag({ invoice, ...rest }: PaymentStatusTagProps) {
  const { t } = useTranslation();

  return (
    <Tag
      variant={getInvoiceStatusTagVariant(invoice)}
      text={t(getInvoiceStatus(invoice))}
      {...rest}
    />
  );
}

export default PaymentStatusTag;
